import { Info } from "lucide-react";
import Loading from "../../shared/Loading";
import { useFormatAmount } from "../../hooks/useFormatAmount";

const ManualPaymentPrompt = ({
  closeManualPaymentPrompt,
  handleContinuePayment,
  loading,
  amount,
}) => {
  const formatAmount = useFormatAmount();
  return (
    <div
      onClick={(e) => {
        closeManualPaymentPrompt();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <Info size={40} color="#F4A261" />
        <p className="text-[#5C5C5C] text-center text-[16px] font-semibold">
          WARNING
        </p>
        <p className="text-[#5C5C5C] text-[14px] font-normal text-center">
          You are about to confirm payment of {formatAmount(amount)} for this
          loan. This action will update the user's balance and cannot be undone.
          Please ensure you have verified the funds in the receiving account.
        </p>
        <div className="flex items-center mt-[20px] justify-center gap-[10px]">
          <button
            onClick={closeManualPaymentPrompt}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Cancel
          </button>
          <button
            disabled={loading}
            onClick={handleContinuePayment}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium flex items-center gap-[5px] justify-center"
          >
            {loading && <Loading />}
            Confirm Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualPaymentPrompt;
